export default __webpack_public_path__ + "static/media/nexcare-logo-out.bf7c3890.svg";